export const customerState: { [key: string]: any } = {
    title: '',
    firstName: '',
    lastName: '',
    birthdate: '',
    email: '',
    mobilePhoneNumber: '',
    streetName: '',
    houseNumber: '',
    addressAddition: '',
    postalCode: '',
    city: '',
    country: '',
};
